import { IComponentOptions, IRootScopeService } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { OkrEvents, goalSelected } from "@gtmhub/okrs/events";
import { PlanningSessionsActions } from "@gtmhub/sessions/redux/session-actions";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { INgRedux } from "@gtmhub/state-management";
import { IPlanningSessionsIdMap } from "@webapp/sessions/models/sessions.model";
import { IGoal, IGoalNode, SingleGoalSelectorInvokedBy } from "../../models";

const bindStateToThis = (state: ISessionsStoreState): IGoalSelectorNodeRedux => ({
  sessionsMap: state.sessions.map,
});

interface IGoalSelectorNodeRedux {
  sessionsMap: IPlanningSessionsIdMap;
}

export class GoalSelectorNodeCtrl extends GtmhubController implements IGoalSelectorNodeRedux {
  // bindings
  g: IGoalNode;
  invokedById: string;
  invokedBy: SingleGoalSelectorInvokedBy;
  unselectableId: string;
  hidePrivate: boolean;
  select: (args: { goal: IGoal }) => void;

  // Redux
  sessionsMap: IPlanningSessionsIdMap;

  public static $inject = ["$rootScope", "$ngRedux", "PlanningSessionsActions"];
  private okrEvents: OkrEvents;

  constructor(private $rootScope: IRootScopeService, private $ngRedux: INgRedux, private planningSessionsActions: PlanningSessionsActions) {
    super();
    this.okrEvents = new OkrEvents(this.$rootScope);
  }

  $onInit(): void {
    this.onDestroy(this.$ngRedux.connect(bindStateToThis)(this));
    this.$ngRedux.dispatch(this.planningSessionsActions.getSessionsIfMissing());
  }

  selectGoal(): void {
    this.okrEvents.broadcastGoalsChanged(goalSelected, { goal: this.g.goal, invokedById: this.invokedById, invokedBy: this.invokedBy });

    this.select({ goal: this.g.goal });
  }
}

export const GoalSelectorNodeComponent: IComponentOptions = {
  template: require("./goal-selector-node.html"),
  controller: GoalSelectorNodeCtrl,
  bindings: {
    g: "=",
    invokedById: "@",
    invokedBy: "@",
    unselectableId: "@",
    hidePrivate: "@",
    select: "&",
  },
};
